import { useState } from 'react';
import { getContainer } from '@framework/di/getContainer';
import TransactionTypeRepository from './TransactionTypeRepository';
import { AlertManager } from '@dealroadshow/uikit-alert';
import { getErrorMessage } from '@framework/message/Mapper/getMessage';
import { IEnhancedTaggingFiltersTransactionType } from '@condor/enhanced-tagging/domain/vo/EnhancedTaggingFilters';

export default function useTransactionTypes(tenant: string) {
  const container = getContainer();
  const [isFetching, setIsFetching] = useState(false);
  const [collection, setCollection] = useState<IEnhancedTaggingFiltersTransactionType[]>([]);

  async function getTransactionTypes(): Promise<IEnhancedTaggingFiltersTransactionType[]> {
    setIsFetching(true);
    try {
      const transactionTypeRepository = container.get<TransactionTypeRepository>(TransactionTypeRepository);
      const response = await transactionTypeRepository.getTransactionTypeList(tenant);
      setCollection(response);
      return response;
    } catch (error) {
      AlertManager.error(getErrorMessage(error));
      return [];
    } finally {
      setIsFetching(false);
    }
  }

  return {
    isFetching,
    collection,
    getTransactionTypes,
  };
}
